import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export default async function addLeads(formData, editKey, callback) {
	console.log('editKeyeditKey', editKey);
	if (editKey) {
		console.log('i am heere??', editKey);
		console.log('add leads', editKey);
		await firebaseRef
			.ref('/kavtek_leads/' + PROJECT_CODE.projectCode + '/' + editKey)
			.update(formData);

		callback('success', 'Lead has been successfully edited!');

		// console.log('leadRef', leadRef);

		// leadRef.update(leadById);
	} else {
		var doesThisClientExist = true;
		console.log(' or i am heere??', editKey);

		await firebaseRef
			.ref('/kavtek_leads/' + PROJECT_CODE.projectCode)
			.orderByChild('clientEmail')
			.equalTo(formData?.clientEmail)
			.limitToFirst(1)
			.once('value', (snapshot) => {
				if (snapshot.val() === null) {
					doesThisClientExist = false;
				}
			});

		if (doesThisClientExist === false) {
			var newLeadRef = await firebaseRef
				.ref('/kavtek_leads/' + PROJECT_CODE.projectCode)
				.push();

			newLeadRef.set(formData);

			callback('success', 'Lead has been successfully saved!');
		} else {
			callback('warning', 'Lead email has been used, please try again!');
		}
	}
}
